import { ApiOptions, parseDateFields } from './Api.hooks';
import { FetchError, FetchRequest } from './api';

export interface RequestResult<T = unknown> {
  data?: T;
  error?: FetchError;
  response?: Response;
}

// resolve api.fetch calls without using hooks
export async function apiResolve<T = unknown>(
  request: FetchRequest,
  options?: ApiOptions
): Promise<RequestResult<T>> {
  const { bodyParse = true } = options || {};
  let response: Response | undefined;
  try {
    response = await request.response;
    // parse if error to get error object
    const json = !response.ok || bodyParse ? await response.json() : {};
    return response.ok
      ? { response, data: parseDateFields(json) }
      : { response, error: json };
  } catch (error) {
    // ignore when request is aborted
    if (error instanceof Error && error.name === 'AbortError') {
      return { response };
    }
    const { name, message } =
      error instanceof Error
        ? error
        : { name: 'Request Error', message: 'An error occurred.' };
    return {
      response,
      error: { error: name, message, statusCode: 500 }
    };
  }
}
